import Logo from "../images/logoInterviewx.svg";
import dcbLogo from "../images/dcbLogo.svg";
import SymbolLogo from "../images/symbolLogo.svg";
import SymbolLogoWhite from "../images/symbolLogoWhite.svg";
import LogoVerticality from "../images/logo-verticality.svg";
import LogoSymbolWhite from "../images/logo-symbol-white.svg";
import Logo2 from "../icons/Logo";
import LogoType from "../icons/LogoType";

import Filter from "../images/Filter.svg";
import BgSearch from "../images/BgSearch.png";
import Search from "../images/Search.svg";

import IconView from "../images/iconView.svg";
import IconCheck from "../images/icoCheck.svg";
import Check from "../images/Check.svg";
import IconClose from "../images/iconClose.svg";
import Interview from "../images/Interview.svg";
import Report from "../images/Report.svg";

import IconDownload from "../images/iconDownload.svg";
import IconDownload2 from "../images/iconDownload2.svg";
import IconDownloadMiro from "../images/iconDownloadMiro.svg";

import BtnFirst from "../images/btnFirst.svg";
import BtnPrev from "../images/btnPrev.svg";
import BtnNext from "../images/btnNext.svg";
import BtnEnd from "../images/btnEnd.svg";

import Chat from "../images/Chat.svg";
import Folder from "../images/Folder.svg";
import File from "../images/File.svg";
import Graph from "../images/Graph.svg";
import Clock from "../images/Clock.svg";

import StarChack from "../images/StarChack.svg";
import IconSetting from "../images/iconSetting.svg";
import IconTarget from "../images/iconTarget.svg";

import IconWrite2 from "../images/iconWrite2.svg";
import IconRefresh from "../images/iconRefresh.svg";
import IconRefresh2 from "../images/iconRefresh2.svg";
import IconEdit from "../images/iconEdit.svg";
import IconCopy from "../images/iconCopy.svg";
import IconSave from "../images/iconSave.svg";

import ImgChat from "../images/imgChat.svg";
import ImgWrite from "../images/imgWrite.svg";
import ImgTarget from "../images/imgTarget.svg";
import IconChatSmile from "../images/iconChatSmile.svg";

import ImgPoC from "../images/imgPoC.svg";
import ImgPoC2 from "../images/imgPoC2.svg";
import ImgMarketing from "../images/imgMarketing.svg";
import ImgClient from "../images/imgClient.svg";
import ImgStrategy from "../images/imgStrategy.svg";
import ImgIdea from "../images/imgIdea.svg";
import ImgHacker from "../images/imgHacker.svg";
import ImgBiz from "../images/imgBiz.svg";
import ImgBM from "../images/imgBM.svg";
import ImgPrice from "../images/imgPrice.svg";
import ImgSurvey from "../images/imgSurvey.svg";
import ImgComing from "../images/imgComing.svg";

import IconSearch from "../images/iconSearch.svg";
import IconSearchHover from "../images/iconSearchHover.svg";

import IconChat from "../images/iconChat.svg";
import IconWrite from "../images/iconWrite.svg";
import IconTarget2 from "../images/iconTarget2.svg";

import ExclamationMark2 from "../images/iconExclamationMark.svg";
import ExclamationMark from "../images/iconExclamationMark1.svg";
import ExclamationMarkRed from "../images/iconExclamationMarkRed.svg";
import CheckMark from "../images/CheckMark.svg";
import iconQuestionMark from "../images/iconQuestionMark.svg";
import iconQuestionMark2 from "../images/iconQuestionMark2.svg";
import QuestionCircle from "../images/question-circle.svg";
import QuestionCirclePrimary from "../icons/QuestionCirclePrimary";
import EventMark from "../images/event-mark.svg";

import ProfessionalValue from "../images/ProfessionalValue.svg";
import ProfessionalRoadmap from "../images/ProfessionalRoadmap.svg";
import ProfessionalPositioning from "../images/ProfessionalPositioning.svg";
import ProfessionalBrand from "../images/ProfessionalBrand.svg";
import ProfessionalContent from "../images/ProfessionalContent.svg";
import ProfessionalDigital from "../images/ProfessionalDigital.svg";
import ProfessionalBehavior from "../images/ProfessionalBehavior.svg";
import ProfessionalUX from "../images/ProfessionalUX.svg";
import ProfessionalData from "../images/ProfessionalData.svg";

import IconDelete from "../images/iconDelete.svg";
import IconWrite3 from "../images/iconWrite3.svg";

import IconEdit2 from "../images/iconEdit2.svg";
import IconDelete2 from "../images/iconDelete2.svg";
import IconClose2 from "../images/iconClose2.svg";
import IconCheck2 from "../images/iconCheck2.svg";
import IconCheck3 from "../images/IconCheck3.svg";

import IconList from "../images/iconList.svg";
import IconSaveDate from "../images/iconSaveDate.svg";

import AccountSetting from "../images/AccountSetting.svg";
import AccountInfo from "../images/AccountInfo.svg";
import AccountInquiry from "../images/AccountInquiry.svg";
import AccountLogout from "../images/AccountLogout.svg";
import IconMagic from "../images/iconMagic.svg";
import IconMagic2 from "../images/iconMagic2.svg";

import iconMailSuccess from "../images/iconMailSuccess.svg";

import ImgPDF from "../images/ImgPDF.svg";
import ImgWord from "../images/ImgWord.svg";
import ImgPDF2 from "../images/ImgPDF2.svg";
import ImgWord2 from "../images/ImgWord2.svg";
import ImgExcel from "../images/ImgExcel.svg";
import ImgExcel2 from "../images/ImgExcel2.svg";

import ImgKOR from "../images/ImgKOR.svg";
import ImgENG from "../images/ImgENG.svg";
import ImgKOR2 from "../images/ImgKOR2.svg";
import ImgENG2 from "../images/ImgENG2.svg";

import IconLightning from "../images/IconLightning.svg";

import IconEdit3 from "../images/iconEdit3.svg";

import IconExpert1 from "../images/iconExpert1.png";
import IconExpert2 from "../images/iconExpert2.png";
import IconExpert3 from "../images/iconExpert3.png";
import IconExpert4 from "../images/iconExpert4.png";
import IconExpert5 from "../images/iconExpert5.png";
import IconExpert6 from "../images/iconExpert6.png";
import IconExpert7 from "../images/iconExpert7.png";
import IconExpert8 from "../images/iconExpert8.png";
import IconExpert9 from "../images/iconExpert9.png";
import IconExpert10 from "../images/iconExpert10.png";

import ImgCanvasBusiness from "../images/imgCanvasBusiness.svg";
import ImgCanvasLean from "../images/imgCanvasLean.svg";

import IconCanvas01 from "../images/iconCanvas01.svg";
import IconCanvas02 from "../images/iconCanvas02.svg";
import IconCanvas03 from "../images/iconCanvas03.svg";
import IconCanvas04 from "../images/iconCanvas04.svg";
import IconCanvas05 from "../images/iconCanvas05.svg";
import IconCanvas06 from "../images/iconCanvas06.svg";
import IconCanvas07 from "../images/iconCanvas07.svg";
import IconCanvas08 from "../images/iconCanvas08.svg";
import IconCanvas09 from "../images/iconCanvas09.svg";
import IconCanvas10 from "../images/iconCanvas10.svg";
import IconCanvas11 from "../images/iconCanvas11.svg";
import IconCanvas12 from "../images/iconCanvas12.svg";
import IconCanvas13 from "../images/iconCanvas13.svg";

import IconDetailView from "../images/IconDetailView.svg";

import ImgMBTIROIC from "../images/ImgMBTI_ROIC.png";
import ImgMBTIROTC from "../images/ImgMBTI_ROTC.png";
import ImgMBTISOIA from "../images/ImgMBTI_SOIA.png";
import ImgMBTIRPTC from "../images/ImgMBTI_RPTC.png";
import ImgMBTIROTA from "../images/ImgMBTI_ROTA.png";
import ImgMBTISPIC from "../images/ImgMBTI_SPIC.png";
import ImgMBTISOTC from "../images/ImgMBTI_SOTC.png";
import ImgMBTIRPIA from "../images/ImgMBTI_RPIA.png";
import ImgMBTIROIA from "../images/ImgMBTI_ROIA.png";
import ImgMBTISPTC from "../images/ImgMBTI_SPTC.png";
import ImgMBTISPIA from "../images/ImgMBTI_SPIA.png";
import ImgMBTIRPTA from "../images/ImgMBTI_RPTA.png";
import ImgMBTISOIC from "../images/ImgMBTI_SOIC.png";
import ImgMBTISOTA from "../images/ImgMBTI_SOTA.png";
import ImgMBTIRPIC from "../images/ImgMBTI_RPIC.png";
import ImgMBTISPTA from "../images/ImgMBTI_SPTA.png";

import IconBell from "../images/bell.svg";
import IconRepeatSquare from "../images/repeat-square.svg";
import PeopleChatSquareFill from "../images/people-chat-square-fill.svg";
import ChatSquareDots from "../images/chat-square-dots.svg";
import MagicStick from "../images/magic-stick.svg";
import MagicStickFillWhite from "../images/magic-stick-fill-white.svg";
import NotePencil from "../images/note-pencil.svg";
import ChevronRight from "../icons/ChevronRight";
// import ChevronRight from "../images/chevron-right.svg"
import ChevronRightPrimary from "../images/chevron-right-primary.svg";
import ChevronDown from "../icons/ChevronDown";
// import ChevronDown from "../images/chevron-down.svg"
import PencilSquare from "../images/pencil-square.svg";
import ClockCounterclockwise from "../images/clock-counterclockwise.svg";
import ClockClockwise from "../icons/ClockClockwise";
import CheckCircle from "../images/check-circle.svg";
import CheckCircleFill from "../images/check-circle-fill.svg";
import FolderArrowDown from "../images/folder-arrow-down.svg";
import StatusBadgeBasic from "../images/status-badge-basic.svg";
import StatusBadgeCustom from "../images/status-badge-custom.svg";
import StatusBadgePersona from "../images/status-badge-persona.svg";
import GenderMen from "../images/gender-men.svg";
import GenderWomen from "../images/gender-women.svg";
import GenderMenPrimary from "../images/gender-men-primary.svg";
import GenderWomenPrimary from "../images/gender-women-primary.svg";
import FileSearch from "../images/file-search.svg";
import PlusSquareWhite from "../images/plus-square-white.svg";
import Plus from "../images/plus.svg";
import PlusPrimary from "../images/plus-primary.svg";
import Gear from "../images/gear.svg";
import ArrowBarLeft from "../images/arrow-bar-left.svg";
import ArrowReturn from "../images/arrow-return.svg";
import ArrowClockwise from "../images/arrow-clockwise.svg";
import ArrowClockwise2 from "../icons/ArrowClockwise";
import NoteArrowUp from "../images/note-arrow-up.svg";
import CheckGreen from "../images/check-green.svg";
import FileText from "../images/file-text.svg";
import People from "../images/people.svg";
import PeopleFill from "../images/people-fill.svg";
import PeopleFill2 from "../icons/PeopleFill";
import ReportSearch from "../images/report-search.svg";
import PersonCircle from "../images/person-circle.svg";
import PersonFill from "../images/person-fill.svg";
import FileFill from "../images/file-fill.svg";
import PeopleFillPrimary from "../images/people-fill-primary.svg";
import PeopleFillPrimary2 from "../images/people-fill-primary2.svg";
import PeopleStarFillPrimary from "../images/people-star-fill-primary.svg";
import ListFillPrimary from "../images/list-fill-primary.svg";
import NoAlarm from "../images/alarm-no.svg";
import ExclamationCircle from "../images/exclamation-circle.svg";
import ExclamationCircleFill from "../images/exclamation-circle-fill.svg";
import BoxArrowUpRight from "../images/box-arrow-up-right.svg";
import CalendarCheck from "../images/calendar-check.svg";
import Headset from "../images/headset.svg";

import PersonaCustomizing from "../images/persona-customizing.png";

// import DiscoveryBrand from "../images/Discovery-Brand.png"
// import DiscoveryInsight from "../images/Discovery-Insight.png"
// import DiscoveryTarget from "../images/Discovery-Target.png"
// import DiscoverySuccess from "../images/Discovery-Success.png"
// import DiscoveryExperience from "../images/Discovery-Experience.png"
// import DiscoveryScale from "../images/Discovery-Scale.png"
// import DiscoveryBM from "../images/Discovery-BM.png"

import DiscoveryBrand from "../images/Discovery-Brand.svg";
import DiscoveryInsight from "../images/Discovery-Insight.svg";
import DiscoveryTarget from "../images/Discovery-Target.svg";
import DiscoverySuccess from "../images/Discovery-Success.svg";
import DiscoveryExperience from "../images/Discovery-Experience.svg";
import DiscoveryScale from "../images/Discovery-Scale.svg";
import DiscoveryBM from "../images/Discovery-BM.svg";

import DiscoveryBrandHover from "../images/Discovery-Brand-hover.png";
import DiscoveryInsightHover from "../images/Discovery-Insight-hover.png";
import DiscoveryTargetHover from "../images/Discovery-Target-hover.png";
import DiscoverySuccessHover from "../images/Discovery-Success-hover.png";
import DiscoveryExperienceHover from "../images/Discovery-Experience-hover.png";
import DiscoveryScaleHover from "../images/Discovery-Scale-hover.png";
import DiscoveryBMHover from "../images/Discovery-BM-hover.png";

import Crown3D from "../images/Crown-3D.png";
import StarFill3D from "../images/Star-Fill-3D.png";

import BgUserChatDots from "../images/bg-user-chat-dots.svg";
import CloseBlack from "../images/close-black.svg";
import Lock from "../images/lock.svg";

// import CoinSmall from "../images/coin-small.svg"
// import CoinMedium from "../images/coin-medium.svg"
// import CoinLarge from "../images/coin-large.svg"
import CoinSmall from "../icons/CoinSmall";
import CoinMedium from "../icons/CoinMedium";
import CoinLarge from "../icons/CoinLarge";
import CoinFill from "../icons/CoinFill";
import CoinLargeFill from "../icons/CoinLargeFill";

import RocketSuccess from "../images/rocket-success.svg";
import RocketFail from "../images/rocket-fail.svg";
import PatchCheckFill from "../images/patch-check-fill.svg";
import KeyCircle from "../images/key-circle.svg";

import ListUserSearch from "../images/list-user-search.svg";
import ChatPlus from "../icons/ChatPlus";

import Repeat from "../images/repeat.svg";
import NoUserThumb from "../images/no-user-thumb.svg";
import ExclamationCircle2 from "../icons/ExclamationCircle";
import ServiceLandingImages from "../images/ServiceLandingImages.svg";
import ServiceLandingImages2 from "../images/ServiceLandingImages2.svg";

import ServiceLandingSection01 from "../images/ServiceLandingSection01.png";
import ServiceLandingSectionBg from "../images/ServiceLandingSectionBg.png";
import ServiceLandingSection02 from "../images/ServiceLandingSection02.png";

import CarouselImg01 from "../images/carousel-img01.png";
import CarouselImg02 from "../images/carousel-img02.png";
import CarouselImg03 from "../images/carousel-img03.png";

import Popup01 from "../images/popup01.png";

import ImgExplore01 from "../images/img-explore01.png";
import ImgExplore02 from "../images/img-explore02.png";
import ImgExplore03 from "../images/img-explore03.png";
import ImgExplore04 from "../images/img-explore04.png";
import ImgExplore05 from "../images/img-explore05.png";
import ImgExplore06 from "../images/img-explore06.png";
import ImgExplore07 from "../images/img-explore07.png";
import ImgExplore08 from "../images/img-explore08.png";
import ImgExplore09 from "../images/img-explore09.png";
import ImgExplore10 from "../images/img-explore10.png";
import ImgExplore11 from "../images/img-explore11.png";
import ImgExplore12 from "../images/img-explore12.png";
import ImgExplore13 from "../images/img-explore13.png";
import ImgExplore14 from "../images/img-explore14.png";
import ImgExplore15 from "../images/img-explore15.png";
import ImgExplore16 from "../images/img-explore16.png";
import ImgExplore17 from "../images/img-explore17.png";
import ImgExplore18 from "../images/img-explore18.png";
import ImgExplore19 from "../images/img-explore19.png";
import ImgExplore20 from "../images/img-explore20.png";
import ImgExplore21 from "../images/img-explore21.png";
import ImgExplore22 from "../images/img-explore22.png";
import ImgExplore23 from "../images/img-explore23.png";
import ImgExplore24 from "../images/img-explore24.png";
import ImgExplore25 from "../images/img-explore25.png";

import ImgExploreNoData from "../images/img-explore-nodata.png";

import LightningChargeFill from "../icons/LightningChargeFill";
import GridTool from "../icons/GridTool";
import GridCircle from "../icons/GridCircle";
import ThreeDotsVertical from "../icons/ThreeDotsVertical";
import GridReport from "../icons/GridReport";

import Tag from "../icons/Tag";
import Report2 from "../icons/Report2";
import ImagePrimary from "../images/image-primary.svg";

import ProjectThumbnail01 from "../images/project-thumbnail01.jpg";
import ProjectThumbnail02 from "../images/project-thumbnail02.jpg";
import ProjectThumbnail03 from "../images/project-thumbnail03.jpg";
import ProjectThumbnail04 from "../images/project-thumbnail04.jpg";
import ProjectThumbnail05 from "../images/project-thumbnail05.jpg";
import ProjectThumbnail06 from "../images/project-thumbnail06.jpg";
import ProjectThumbnail07 from "../images/project-thumbnail07.jpg";
import ProjectThumbnail08 from "../images/project-thumbnail08.jpg";
import ProjectThumbnail09 from "../images/project-thumbnail09.jpg";
import ProjectThumbnail10 from "../images/project-thumbnail10.jpg";
import ProjectThumbnail11 from "../images/project-thumbnail11.jpg";
import ProjectThumbnail12 from "../images/project-thumbnail12.jpg";
import ProjectThumbnail13 from "../images/project-thumbnail13.jpg";
import ProjectThumbnail14 from "../images/project-thumbnail14.jpg";
import ProjectThumbnail15 from "../images/project-thumbnail15.jpg";
import ProjectThumbnail16 from "../images/project-thumbnail16.jpg";
import ProjectThumbnail17 from "../images/project-thumbnail17.jpg";
import ProjectThumbnail18 from "../images/project-thumbnail18.jpg";
import ProjectThumbnail19 from "../images/project-thumbnail19.jpg";
import ProjectThumbnail20 from "../images/project-thumbnail20.jpg";

import Tools from "../images/tools.svg";

import Star from "../images/Star.svg";
import StarFill from "../images/StarFill.svg";

import NoData from "../images/Nodata.svg";

import ProjectTag from "../icons/ProjectTag";

import ProjectInformation from "../images/Project-Information.svg";
import ProjectBanking from "../images/Project-Banking.svg";
import ProjectProduction from "../images/Project-Production.svg";
import ProjectBuild from "../images/Project-Build.svg";
import ProjectMedical from "../images/Project-Medical.svg";
import ProjectEducation from "../images/Project-Education.svg";
import ProjectConsumer from "../images/Project-Consumer.svg";
import ProjectEtc from "../images/Project-Etc.svg";

import ProjectKorea from "../images/Project-korea.svg";
import ProjectUsa from "../images/Project-usa.svg";
import ProjectChina from "../images/Project-china.svg";
import ProjectJapan from "../images/Project-japan.svg";
import ProjectVietnam from "../images/Project-vietnam.svg";
import ProjectTaiwan from "../images/Project-taiwan.svg";

import Image from "../images/image.svg";
import Trash from "../images/trash.svg";

import InterviewModeSelfQuestion from "../images/InterviewModeSelfQuestion.svg";
import InterviewModeModerator from "../images/InterviewModeModerator.svg";
import aatLogo from "../images/aatLogo.png";


const images = {
  Logo,
  dcbLogo,
  aatLogo,
  SymbolLogo,
  SymbolLogoWhite,
  LogoVerticality,
  LogoSymbolWhite,
  Logo2,
  LogoType,

  Filter,
  BgSearch,
  Search,

  IconView,
  IconCheck,
  Check,
  IconClose,
  Interview,
  Report,

  IconDownload,
  IconDownload2,
  IconDownloadMiro,

  BtnFirst,
  BtnPrev,
  BtnNext,
  BtnEnd,

  Chat,
  Folder,
  File,
  Graph,
  Clock,

  StarChack,
  IconSetting,
  IconTarget,

  IconWrite2,
  IconRefresh,
  IconRefresh2,
  IconEdit,
  IconCopy,
  IconSave,

  ImgChat,
  ImgWrite,
  ImgTarget,
  IconChatSmile,

  ImgPoC,
  ImgPoC2,
  ImgMarketing,
  ImgClient,
  ImgStrategy,
  ImgIdea,
  ImgHacker,
  ImgBiz,
  ImgBM,
  ImgPrice,
  ImgSurvey,
  ImgComing,

  IconSearch,
  IconSearchHover,

  IconChat,
  IconWrite,
  IconTarget2,

  ExclamationMark2,
  ExclamationMark,
  ExclamationMarkRed,
  CheckMark,
  iconQuestionMark,
  iconQuestionMark2,
  QuestionCircle,
  QuestionCirclePrimary,
  EventMark,

  ProfessionalValue,
  ProfessionalRoadmap,
  ProfessionalPositioning,
  ProfessionalBrand,
  ProfessionalContent,
  ProfessionalDigital,
  ProfessionalBehavior,
  ProfessionalUX,
  ProfessionalData,

  IconDelete,
  IconWrite3,

  IconEdit2,
  IconDelete2,
  IconClose2,
  IconCheck2,
  IconCheck3,

  IconList,
  IconSaveDate,

  AccountSetting,
  AccountInfo,
  AccountInquiry,
  AccountLogout,

  IconMagic,
  IconMagic2,
  iconMailSuccess,

  ImgPDF,
  ImgWord,
  ImgPDF2,
  ImgWord2,
  ImgExcel,
  ImgExcel2,
  ImgKOR,
  ImgENG,
  ImgKOR2,
  ImgENG2,

  IconLightning,

  IconEdit3,

  IconExpert1,
  IconExpert2,
  IconExpert3,
  IconExpert4,
  IconExpert5,
  IconExpert6,
  IconExpert7,
  IconExpert8,
  IconExpert9,
  IconExpert10,

  ImgCanvasBusiness,
  ImgCanvasLean,

  IconCanvas01,
  IconCanvas02,
  IconCanvas03,
  IconCanvas04,
  IconCanvas05,
  IconCanvas06,
  IconCanvas07,
  IconCanvas08,
  IconCanvas09,
  IconCanvas10,
  IconCanvas11,
  IconCanvas12,
  IconCanvas13,

  IconDetailView,

  ImgMBTIROIA,
  ImgMBTIROIC,
  ImgMBTIROTC,
  ImgMBTIROTA,
  ImgMBTIRPIA,
  ImgMBTIRPIC,
  ImgMBTIRPTA,
  ImgMBTIRPTC,

  ImgMBTISOIA,
  ImgMBTISOIC,
  ImgMBTISOTA,
  ImgMBTISOTC,
  ImgMBTISPIA,
  ImgMBTISPIC,
  ImgMBTISPTC,
  ImgMBTISPTA,

  IconBell,
  IconRepeatSquare,
  PeopleChatSquareFill,
  ChatSquareDots,
  MagicStick,
  MagicStickFillWhite,
  NotePencil,
  ChevronRight,
  ChevronRightPrimary,
  ChevronDown,
  PencilSquare,
  ClockCounterclockwise,
  ClockClockwise,
  CheckCircle,
  CheckCircleFill,
  FolderArrowDown,
  StatusBadgeBasic,
  StatusBadgeCustom,
  StatusBadgePersona,
  GenderMen,
  GenderWomen,
  GenderMenPrimary,
  GenderWomenPrimary,
  FileSearch,
  PlusSquareWhite,
  Plus,
  PlusPrimary,
  Gear,
  ArrowBarLeft,
  ArrowReturn,
  ArrowClockwise,
  ArrowClockwise2,
  NoteArrowUp,
  CheckGreen,
  FileText,
  People,
  PeopleFill,
  PeopleFill2,
  ReportSearch,
  PersonCircle,
  PersonFill,
  FileFill,
  PeopleFillPrimary,
  PeopleFillPrimary2,
  ListFillPrimary,
  PeopleStarFillPrimary,
  NoAlarm,
  ExclamationCircle,
  ExclamationCircleFill,
  BoxArrowUpRight,
  CalendarCheck,
  Headset,

  PersonaCustomizing,

  DiscoveryBrand,
  DiscoveryInsight,
  DiscoveryTarget,
  DiscoverySuccess,
  DiscoveryExperience,
  DiscoveryScale,
  DiscoveryBM,

  DiscoveryBrandHover,
  DiscoveryInsightHover,
  DiscoveryTargetHover,
  DiscoverySuccessHover,
  DiscoveryExperienceHover,
  DiscoveryScaleHover,
  DiscoveryBMHover,

  Crown3D,
  StarFill3D,

  BgUserChatDots,
  CloseBlack,
  Lock,

  CoinSmall,
  CoinMedium,
  CoinLarge,
  CoinFill,
  CoinLargeFill,

  RocketSuccess,
  RocketFail,
  PatchCheckFill,
  KeyCircle,

  ListUserSearch,
  ChatPlus,

  Repeat,
  NoUserThumb,

  ExclamationCircle2,
  ServiceLandingImages,
  ServiceLandingImages2,

  ServiceLandingSection01,
  ServiceLandingSectionBg,
  ServiceLandingSection02,

  CarouselImg01,
  CarouselImg02,
  CarouselImg03,

  Popup01,

  ImgExplore01,
  ImgExplore02,
  ImgExplore03,
  ImgExplore04,
  ImgExplore05,
  ImgExplore06,
  ImgExplore07,
  ImgExplore08,
  ImgExplore09,
  ImgExplore10,
  ImgExplore11,
  ImgExplore12,
  ImgExplore13,
  ImgExplore14,
  ImgExplore15,
  ImgExplore16,
  ImgExplore17,
  ImgExplore18,
  ImgExplore19,
  ImgExplore20,
  ImgExplore21,
  ImgExplore22,
  ImgExplore23,
  ImgExplore24,
  ImgExplore25,
  ImgExploreNoData,

  LightningChargeFill,
  GridTool,
  GridCircle,
  ThreeDotsVertical,
  GridReport,

  Tag,
  Report2,
  ImagePrimary,

  ProjectThumbnail01,
  ProjectThumbnail02,
  ProjectThumbnail03,
  ProjectThumbnail04,
  ProjectThumbnail05,
  ProjectThumbnail06,
  ProjectThumbnail07,
  ProjectThumbnail08,
  ProjectThumbnail09,
  ProjectThumbnail10,
  ProjectThumbnail11,
  ProjectThumbnail12,
  ProjectThumbnail13,
  ProjectThumbnail14,
  ProjectThumbnail15,
  ProjectThumbnail16,
  ProjectThumbnail17,
  ProjectThumbnail18,
  ProjectThumbnail19,
  ProjectThumbnail20,

  Tools,

  Star,
  StarFill,

  NoData,

  ProjectTag,

  ProjectInformation,
  ProjectBanking,
  ProjectProduction,
  ProjectBuild,
  ProjectMedical,
  ProjectEducation,
  ProjectConsumer,
  ProjectEtc,

  ProjectKorea,
  ProjectUsa,
  ProjectChina,
  ProjectJapan,
  ProjectTaiwan,

  Image,
  Trash,

  InterviewModeSelfQuestion,
  InterviewModeModerator,
};

export default images;
